<template>
	<footer class="footer">
		<div class="container">


			<div class="copyright">
				<b>&copy; {{ new Date().getFullYear() }}</b> <b><span class="text-primary"> HYDRO-D LAB</span></b>
			</div>
			<div class="copyright text-center">
				Developed by <span class="text-primary"><b>Traware Technologies</b></span>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Layout/ContentFooter.vue